<script>
    import { Ribbon } from '@oat-sa-private/ui-components';
    import { activeRibbon } from '@/store/ribbon';
    import { activeTab } from '@/store/navigation';
    import { getPresets } from '@/component/ui-elements/ribbonContainer/ribbonPresets';
</script>

<style>
    .ribbon-container {
        position: fixed;
        width: 100%;
        bottom: 0;
    }
</style>

{#if $activeRibbon}
    <div class="ribbon-container">
        <Ribbon {...getPresets($activeTab)[$activeRibbon]} />
    </div>
{/if}
